<template>
  <div id="document-campaign-list">
    <b-card no-body class="p-2 container-card mb-1">
      <b-row>
        <b-col cols="12">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                :btn-label="'Campaign'"
                @click.native="onOpenModalCreateCampaign(null)"
              />
              <export-button class="ml-2" @onExport="onOpenExportModal" />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <div class="mr-1 ml-1 mb-1">
                <v-select
                  id="campaign-type-status"
                  class="v-select-filter bg-document-list bg-dropdown"
                  :class="status ? 'v-select-filter-selected' : null"
                  placeholder="Status"
                  :options="statusOption"
                  @input="(option) => onSelectFilter('status', option)"
                />
              </div>

              <div class="search-container mb-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <b-table
                :fields="fields"
                :items="documentListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              >
                <template #head(seq)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(seq)="data">
                  <div class="text-center">
                    {{ data.item.seq }}
                  </div>
                </template>
                <template #head(ref_campaign)="data">
                  <div class="text-left">
                    {{ data.label }}
                  </div>
                </template>
                <template #head(name)="data">
                  <div class="text-left">
                    {{ data.label }}
                  </div>
                </template>
                <template #head(qty)="data">
                  <div class="text-center">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(qty)="data">
                  <div class="text-center">
                    {{ data.item.qty }}
                  </div>
                </template>
                <template #head(status)="data">
                  <div class="text-left">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(status)="data">
                  <div
                    v-if="data.item.status == 1"
                    class="d-flex align-items-center"
                  >
                    <feather-icon
                      v-if="data.item.status"
                      icon="CircleIcon"
                      class="active-icon mr-2"
                    />
                    <span>{{ "Active" }}</span>
                  </div>
                  <div v-else class="d-flex align-items-center">
                    <feather-icon
                      icon="CircleIcon"
                      class="inActive-icon mr-2"
                    />
                    <span class="inActive-label">{{ "Inactive" }}</span>
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div class="cursor-pointer">
                    <div class="d-flex justify-content-center">
                      <b-button
                        v-b-tooltip.hover
                        title="Edit"
                        variant="secondary"
                        class="default-btn-action mr-2"
                        @click="
                          onOpenModalCreateCampaign(data.item.container_id)
                        "
                      >
                        <edit-icon
                          class="default-btn-action-svg iconEdit-btn"
                        />
                      </b-button>
                      <b-button
                        v-b-tooltip.hover
                        variant="secondary"
                        class="default-btn-action mr-4 iconSvg-btn"
                        title="Detail"
                        @click="
                          $router
                            .push(
                              `/campaign/list/document-detail/` +
                                data.item.container_id
                            )
                            .catch(() => {})
                        "
                      >
                        <detail-icon
                          class="default-btn-action-svg width-size h-auto"
                        />
                      </b-button>
                    </div>
                  </div>
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <campaign-create-modal
      v-if="modalType.createCampaign"
      :container-id="campaignSelect"
      @onCloseModal="onCloseModalCampaign"
    />
    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.document"
    />
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DetailIcon from "@/@core/components/svg/common/IconDetail2.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";

import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import useDocumentList from "./hooks/useDocumentList";
import CampaignCreateModal from "./components/CampaignCreateModal.vue";
import ExportButton from "@/views/components/button/ExportButton.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    Search,
    vSelect,
    PaginationWithReorder,
    CampaignCreateModal,
    ActionGroup,
    EditIcon,
    DetailIcon,
    ExportButton,
    HistoryReportModal,
  },

  setup() {
    const {
      fields,
      loading,
      statusOption,
      status,
      documentListTable,
      campaignActionList,
      pagination,
      modalType,
      campaignSelect,
      onPageChange,
      onFilterEntity,
      onCloseModalCampaign,
      onOpenModalCreateCampaign,
      onSelectFilter,
      onSetValueSearch,
      resolveMappingTableAction,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    } = useDocumentList();

    return {
      fields,
      loading,
      statusOption,
      status,
      documentListTable,
      modalType,
      pagination,
      campaignActionList,
      campaignSelect,
      onPageChange,
      onFilterEntity,
      onCloseModalCampaign,
      onOpenModalCreateCampaign,
      onSelectFilter,
      onSetValueSearch,
      resolveMappingTableAction,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/override-styles/status.css";

.width-size {
  width: 1.6rem;
}

.btn-action,
.btn-action:active {
  border: none;
  background: transparent !important;
  padding: 0;
}

.btn-action-svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.btn-action-svg.active {
  transform: rotate(180deg);
}

.btn-group-action-svg {
  width: 20px;
  height: 20px;
  transition: transform 0.3s;
}

.btn-group-action-svg.active {
  transform: rotate(180deg);
}
</style>
